export default "__VITE_ASSET__843aef85__"